<template>
  <div class="homeBox">
    <section>
      <div class="header-Box">
        <span class="GPUtitle blueTextColor">Join Our AI Grid network</span>
        <div class="header-text">
          <p>
            Join our GPU provider network! Meet the criteria below and we'll set up your GPU in our IDC. Register now to get started.
          </p>
          <img src="../assets/img/banner.svg" alt="" />
        </div>

        <el-row class="careerInfoFlex careerInfoBox">
          <p class="blueTextColor hardwareTitle">
            <img src="../assets/img/requirements.png" alt="" />Hardware
            Requirements
          </p>
          <el-col :xs="24" :sm="12">
            <div class="careerInfo marginLeft5">
              <!-- <p class="blueTextColor"><img src="../assets/img/requirements.png" alt="">Hardware Requirements </p> -->
              <span>Minimum 8 servers required</span><br />
              <span>Each server:</span>
              <ul>
                <li>CPU: AMD EPYC™ 7002/7003 Series Processor x 2</li>
                <li>Memory: 64GB/DDR4/3200MHz/ECC/REG x 8</li>
                <li>Storage: 1.92TB/NVMe/U.2/Enterprise-grade x 4</li>
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="careerInfo marginLeft10">
              <!-- <p class="blueTextColor">IDC location<img src="../assets/img/location.png" alt=""></p> -->
              <span></span><br />
              <span></span>
              <br />
              <ul>
                <li>Network Card: 10Gb/25Gb Dual-Port/Fiber SFP+ x 1</li>
                <li>PCIe Expansion: PCI-E 4.0 X 16 x 8</li>
                <li>GPU: RTX 4090 24GB x8</li>
                <li class="list-style-none"></li>
                <li class="list-style-none"></li>
                <li class="list-style-none"></li>
              </ul>
              <!-- <span>We're growing rapidly - more IDC locations loading!</span> -->
            </div>
          </el-col>
        </el-row>
        <el-row class="careerInfoFlex">
          <el-col :xs="24" :sm="12">
            <div class="careerInfo marginLeft10">
              <p class="btnNotice">Ready to Power?</p>
              <button
                class="blueBtnColor"
                onclick="window.location.href='https://powermeta.ai/Contactus'"
              >
                Become a GPU Provider
              </button>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="careerInfo marginLeft15">
              <p class="btnNotice">Don’t Have A GPU?</p>
              <button
                class="blueBtnColor"
                onclick="window.location.href='https://www.araratglobal.io/ai-factory'"
              >
                Browse Options
              </button>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "JoinGpu",
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-Box {
  width: 100%;
  background-color: #08071b;
  position: relative;
  overflow: hidden;
  text-align: center;
  padding-bottom: 100px;
  padding-top: 135px;
}
.GPUtitle {
  font-size: 50px;
  line-height: 90px;
  font-family: Michroma;
}
.header-text {
  color: #fff;
  max-width: 92%;
  text-align: center;
  // white-space: nowrap;
  margin: 0 auto;
  p {
    font-size: 16px;
    line-height: 30px;
    font-family: Montserrat;
  }
  img {
    max-width: 92%;
    margin-top: 10px;
  }
}
.careerInfoBox {
  padding-top: 54px;
}
.careerInfoFlex {
  width: 80%;
  margin: 0 auto;
  margin-top: 65px;
}
.careerInfo {
  text-align: center;
  text-align: left;
  // width: 90%;
  position: relative;
  // border: 1px solid red;
  left: 50%;
  transform: translateX(-50%);
  p {
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 18px;
    font-family: Michroma;
    display: flex;
    // justify-content: center;
    align-items: center;
  }
  img {
    height: 40px;
    margin-left: 10px;
  }
  .btnNotice {
    font-family: Michroma;
    font-weight: 400;
    line-height: 38px;
    color: #fff;
  }
  ul,
  span {
    color: #fff;
    font-size: 20px;
    line-height: 38px;
    font-family: Montserrat;
    font-weight: 600;
  }
  ul {
    padding-left: 20px;
  }
  li {
    list-style-type: disc;
  }
  .list-style-none {
    visibility: hidden;
  }
  button {
    min-width: 310px;
    height: 58px;
    border-radius: 22px;
    font-family: DMSans;
    font-size: 16px;
    font-weight: 500;
    line-height: 45px;
    border: none;
  }
}
.hardwareTitle {
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 18px;
  font-family: Michroma;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    margin-right: 20px;
  }
}
.marginLeft5 {
  margin-left: 5%;
}
.marginLeft10 {
  margin-left: 10%;
}
.marginLeft15 {
  margin-left: 15%;
}
// 响应式
@media only screen and (max-width: 767px) {
  .header-Box {
    padding-top: 40px;
  }
  .GPUtitle {
    font-size: 20px;
    line-height: 35px;
  }
  .header-text p {
    font-size: 16px;
  }
  .careerInfo {
    ul,
    span {
      font-size: 14px;
    }
    p {
      font-size: 16px;
    }
  }
  .hardwareTitle{
    justify-content: left;
    font-size: 16px;
    img{
      margin-right: 10px;
    }
  }
  button {
    width: 300px;
    max-width: 100%;
  }
  .careerInfoFlex {
    width: 90%;
    margin-top: 10px;
    padding-top: 20px;
  }
  .careerInfo img {
    height: 24px;
  }
  .marginLeft5,
  .marginLeft10,
  .marginLeft15 {
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) {
  .header-text img {
    height: 390px;
    // width: 760px;
  }
}
</style>
